import { getAlumno } from './api'
import { useLocation } from 'react-router-dom'
import { createContext, useState, useContext, useEffect } from 'react'

const Context = createContext()

export const AlumnoManager = ({ children }) => {

  const location = useLocation()
  const search = new URLSearchParams(location.search)
  const token = search.get("token")

  const [isCompleted, setCompleted] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(false)
  const [alumno, setAlumno] = useState(null)

  useEffect(()=> {
    setCompleted(false)
  }, [token])

  useEffect(()=> {
    if (isCompleted) return
    if (!token) {
      setCompleted(true)
      return
    }
    if (isLoading) return
    setLoading(true)
    getAlumno(token)
    .then(({ success, data })=> {
      if (success) setAlumno(data)
      else setError(true)
    })
    .finally(()=> {
      setLoading(false)
      setCompleted(true)
    })
  }, [token, isLoading, isCompleted])

  const isReady = isCompleted && Boolean(alumno)

  return (
    <Context.Provider value={{ token, isLoading, isReady, isCompleted, isError, alumno }}>
      {children}
    </Context.Provider>
  )
}

export const useAlumno = () => useContext(Context)